function init(): void{
  const savedItemButtons = document.querySelectorAll<HTMLButtonElement>(".saved-items-button:not([data-event-attached=\"true\"])");

  const changeButtonActiveState = (button: HTMLButtonElement, isActive: boolean) => {
    const buttonText = button.querySelector<HTMLElement>('.saved-items-button__text');

    if (isActive === true) {
      button.classList.add('active')
      buttonText.textContent = button.dataset.savedText;
      return;
    }

    button.classList.remove('active')
    buttonText.textContent = button.dataset.saveText;
  }

  const getSavedState = (button: HTMLButtonElement) => button.classList.contains('active');

  const onToggleSavedItemButton = async (e: MouseEvent) => {
    const button = e.currentTarget as HTMLButtonElement;

    if (!button) return;

    const isSaved = getSavedState(button);
    const contentId = button.dataset.contentId;
    const updateSaveStateApiUrl = button.dataset.updateSaveStateApiUrl;

    if (!contentId || !updateSaveStateApiUrl) return;

    try {
      button.disabled = true;
      changeButtonActiveState(button, !isSaved);

      const response = await fetch(updateSaveStateApiUrl, {
        method: "POST",
        body: JSON.stringify({ state: !isSaved, contentId: contentId }),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application:json",
        },
      });

      if (response.status !== 200) {
        throw new Error(`There was a problem. Status Code: ${response.status}`);
      }

    } catch (error) {
      console.log(error);
      changeButtonActiveState(button, isSaved);
    } finally {
      button.disabled = false;
    }
  };

  const getSaveState = async (button: HTMLButtonElement) => {
    const getSaveListApiUrl = button.dataset.getSaveListApiUrl;
    const contentId = button.dataset.contentId;

    if (!getSaveListApiUrl || !contentId) return;

    try {
      button.disabled = true;

      const response = await fetch(getSaveListApiUrl, {
        method: "POST",
        body: JSON.stringify([contentId]),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application:json",
        },
      });

      if (response.status !== 200) {
        console.error(`There was a problem. Status Code: ${response.status}`);
        return;
      }

      const saveData = await response.json() as {
        contentId: string;
        state: boolean
      }[];

      if (!saveData) {
        console.error(`There was a problem. Status Code: ${response.status}`);
      }

      const itemState = saveData.find(item => item?.contentId === contentId);

      if (!itemState) {
        console.error(`There was a problem. Status Code: ${response.status}`);
      }

      changeButtonActiveState(button, itemState.state);
    } catch (error) {
      console.error(`There was a problem. Error: ${error}`);
    } finally {
      button.disabled = false;
    }
  };

  savedItemButtons.forEach(async savedItemButton => {
    savedItemButton.dataset.eventAttached = "true";

    savedItemButton.addEventListener("click", onToggleSavedItemButton);

    await getSaveState(savedItemButton);
  });
}

export default { init };
